import React from "react";
import { useTranslation } from "@litres-libs/i18n";
import type { IGenre, RootState, AppDispatch } from "@litres-core/store";
import { SmartLink } from "@litres-modules/smart-link";
import { useDispatch, useSelector } from "react-redux";
import { api } from "@litres-core/store";
import { StyledLink } from "@litres/ui-kit/link";
import { Item } from "../Item/Item";
import type { ColumnProps } from "../../types";
import styles from "./Column.module.scss";
import { capitalizeFirstLetter } from "../../utils";

export const Column = (props: ColumnProps): JSX.Element => {
  const { genre, showPreview } = props;

  const dispatch = useDispatch<AppDispatch>();
  const history = useSelector(
    (state: RootState) => state.global.genres.popup.history
  );
  const isUserAnonymous = useSelector(
    (state: RootState) => state.user.credentials.isAnon
  );
  const { t } = useTranslation();
  const { subgenres, url = "" } = genre;

  const isMoreGenres = subgenres && subgenres.length > 5;

  const onMoreGenresClick = (): void => {
    setTimeout(() => {
      dispatch(api.global.genres.setCurrentGenre(genre));
      dispatch(api.global.genres.setHistory([...history, genre]));
      showPreview(true);
    }, 0);
  };

  return (
    <div className={styles.column}>
      <StyledLink className={styles.title} href={url}>
        {capitalizeFirstLetter(t(genre.name))}
      </StyledLink>
      {subgenres && (
        <ul className={styles.list}>
          {subgenres.map((itemGenre: IGenre, index: number) => {
            if (index < 5) {
              const { id, name } = itemGenre;

              return (
                <Item
                  genre={itemGenre}
                  key={id.toString() + name}
                  isUserAnonymous={isUserAnonymous}
                />
              );
            } else {
              return;
            }
          })}
          {isMoreGenres && (
            <li className={styles["more-genres"]}>
              <SmartLink onClick={onMoreGenresClick}>
                {t("Все")} {subgenres.length}
              </SmartLink>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
